import React from 'react'

export const BurgerMenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 6C2 5.44772 2.44772 5 3 5H17.3636C17.9159 5 18.3636 5.44772 18.3636 6C18.3636 6.55228 17.9159 7 17.3636 7H3C2.44772 7 2 6.55228 2 6ZM2 18C2 17.4477 2.44772 17 3 17H17.3636C17.9159 17 18.3636 17.4477 18.3636 18C18.3636 18.5523 17.9159 19 17.3636 19H3C2.44772 19 2 18.5523 2 18ZM6.63623 11C6.08395 11 5.63623 11.4477 5.63623 12C5.63623 12.5523 6.08395 13 6.63623 13H20.9999C21.5522 13 21.9999 12.5523 21.9999 12C21.9999 11.4477 21.5522 11 20.9999 11H6.63623Z"
      fill="#273754"
    />
  </svg>
)
